import moment from 'moment'

const convertUnixToTimestamp = (unixDate) => unixDate && moment(unixDate * 1000)

export default convertUnixToTimestamp
